// Translation file for FejlesztesiJavaslatok component
// Contains all UI text in Hungarian and English

export const FEJLESZTESIJAVASLATOK_TRANSLATIONS = {
    hu: {
        pageTitle: "7. Fejlesztési prioritások (max. 3)",
        
        section1: {
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "7. Development Priorities (Maximum of 3)",
        
        section1: {
            noteLabel: "Comments (optional):",
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
